import { DiamondMark } from "./Brand";

const ITEMS = ["Limited-time sale", "Tap in to access our supplier directory", "Vetted & hand-checked suppliers", "Level up your reselling game"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center gap-8 pr-8 font-display italic text-xl sm:text-3xl text-[#1A0B33] whitespace-nowrap">
        {t}
        <DiamondMark className="w-4 h-4 sm:w-5 sm:h-5" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative bg-gold-sheet py-5 sm:py-6 overflow-hidden -rotate-1 scale-[1.02] my-6 shadow-[0_0_60px_rgba(212,175,55,0.25)]" data-testid="sale-marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
      <Row hidden />
      <Row hidden />
    </div>
  </section>
);
